import { MenuIcon } from 'lucide-react';
import { Button } from '@/components/common/Button';
import {
    Sheet,
    SheetHeader,
    SheetContent,
    SheetTrigger,
    SheetTitle,
    SheetDescription,
    SheetClose
} from '@/components/common/Sheet';
import { ROUTES } from '@/configs/constants';
import * as VisuallyHidden from '@radix-ui/react-visually-hidden';
import React from 'react';
import { Link } from 'react-router-dom';
import Menu from './_components/Menu';
import FullLogo from '@/assets/images/logo.svg';

interface WrapperSheetCloseProps {
    useSheetClose?: boolean
}

export const WrapperSheetClose = React.forwardRef<
    HTMLDivElement,
    React.HTMLAttributes<HTMLDivElement> & WrapperSheetCloseProps
>(({ children, useSheetClose, ...props }, ref) => (
    <div ref={ref} {...props}>
        {
            !useSheetClose ?
                (
                    <>{children}</>
                ) :
                (
                    <SheetClose asChild>{children}</SheetClose>
                )
        }
    </div>
));
WrapperSheetClose.displayName = 'WrapperSheetClose';

export default function SheetMenu() {
    return (
        <Sheet>
            <SheetTrigger className='lg:hidden' asChild>
                <Button className='h-8 group' variant='outline' size='icon'>
                    <MenuIcon size={20} className='text-active group-hover:text-white' />
                </Button>
            </SheetTrigger>
            <SheetContent
                className='w-[19rem] px-3 h-full flex flex-col'
                side='left'
            >
                <SheetHeader>
                    <SheetTitle>
                        <VisuallyHidden.Root>Sheet Menu</VisuallyHidden.Root>
                    </SheetTitle>
                    <SheetDescription>
                        <VisuallyHidden.Root>
                            Description goes here
                        </VisuallyHidden.Root>
                    </SheetDescription>
                    <WrapperSheetClose useSheetClose>
                        {/* Brand top */}
                        <Button
                            className='transition-transform ease-in-out duration-300 mb-1 h-9 translate-x-0'
                            variant='link'
                            asChild
                        >
                            <Link
                                to={ROUTES.dashboard.href}
                                className='flex items-center justify-center w-full'
                            >
                                <img src={FullLogo} className='h-11' alt='logo' />
                            </Link>
                        </Button>
                    </WrapperSheetClose>
                </SheetHeader>
                <Menu useSheetClose />
            </SheetContent>
        </Sheet>
    );
}
